import React, { useState, ReactElement } from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { SocialLinks } from "./SocialLinks"
import { StoreLinks } from "./StoreLinks"
import * as styles from "./footer.module.scss"

const defaultText = (
  <>
    © 2004-{new Date().getFullYear()}, ПАО «Совкомбанк». Все права защищены.
    <br />
    Генеральная лицензия Банка России №963 <br className={styles.br} />
    от 5 декабря 2014 г.
  </>
)

export const textWithAdress = (
  <>
    ПАО «Совкомбанк». г. Кострома, пр. Текстильщиков, 46. ОГРН <br />{" "}
    1144400000425.Генеральная лицензия Банка России №963 от 5 декабря 2014 г.
  </>
)

type Props = {
  ligal?: string
  isRedButton?: boolean
  withSocialLinks?: boolean
  withStoreLinks?: boolean
  showMoreBtn?: boolean
  orderNum?: string
  footerColor?: boolean
  bottomText?: ReactElement
  blueVariant?: boolean
  darkVariant?: boolean
  paleVariant?: boolean
  marginTop?: boolean
  isButtonFloating?: boolean
  variant?: "default" | "mainPage" | "checkNumber"
  whiteText?: boolean
  variantStyle?: "dkpzMediaVariant"
  leftSide?: boolean
}

export const Footer = ({
  ligal = "",
  isRedButton,
  marginTop = false,
  withSocialLinks = false,
  withStoreLinks = false,
  showMoreBtn = true,
  orderNum,
  footerColor = false,
  bottomText = defaultText,
  blueVariant = false,
  darkVariant = false,
  paleVariant = false,
  isButtonFloating = false,
  variant = "default",
  whiteText = false,
  variantStyle,
  leftSide = false,
}: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const isMobile = useMediaQuery("(max-width:599.5px)")

  return (
    <div
      data-exclude={orderNum}
      id="footer"
      className={clsx(
        {
          [styles.footerColor]: footerColor,
        },
        {
          [styles.blueVariant]: blueVariant,
        },
        {
          [styles.darkVariant]: darkVariant,
        },
        {
          [styles.paleVariant]: paleVariant,
        },
        {
          [styles.marginTop]: marginTop,
        },
        variantStyle && styles[variantStyle]
      )}
    >
      <Container>
        <div
          className={clsx(
            darkVariant ? styles.wrapperDarkVariant : styles.wrapper,
            styles[variant],
            isButtonFloating && isMobile && styles.wrapperButtonFloating
          )}
        >
          {withSocialLinks && <SocialLinks leftSide={leftSide} />}
          {ligal && (
            <div
              className={clsx(styles.text, expanded && styles.hide, {
                [styles.blueVariant]: blueVariant,
              })}
              dangerouslySetInnerHTML={{ __html: ligal }}
              id="ligal"
            />
          )}

          {showMoreBtn && (
            <button
              type="button"
              onClick={() => setExpanded((prev) => !prev)}
              className={clsx(
                styles.button,
                isRedButton ? styles.redButton : ""
              )}
            >
              {expanded ? "Скрыть" : "Подробнее"}
            </button>
          )}
          <div className={styles.block}>
            <p
              className={clsx(
                styles.text,
                {
                  [styles.blueVariant]: blueVariant,
                },
                { [styles.whiteText]: whiteText }
              )}
            >
              {bottomText}
            </p>
            {withStoreLinks && <StoreLinks />}
          </div>
        </div>
      </Container>
    </div>
  )
}
